import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { FaFacebookF } from 'react-icons/fa6'
import { FaGoogle } from 'react-icons/fa6'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { customer_login, messageClear } from '../store/reducers/authReducer'
import toast from 'react-hot-toast'
import { FadeLoader } from 'react-spinners'
import { useTranslation } from 'react-i18next'

const Login = () => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const navigate = useNavigate()
  const { loader, errorMessage, successMessage, userInfo } = useSelector(
    (state) => state.auth,
  )
  const dispatch = useDispatch()

  const [state, setState] = useState({
    phone: '',
    password: '',
  })

  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    })
  }

  const login = (e) => {
    e.preventDefault()
    dispatch(customer_login(state))
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      dispatch(messageClear())
    }
    if (errorMessage) {
      toast.error(errorMessage)
      dispatch(messageClear())
    }
    if (userInfo) {
      navigate('/')
    }
  }, [successMessage, errorMessage])

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}
      <Header />
      <div className="bg-slate-100 mt-4">
        <div className="w-full justify-center items-center p-10 sm:p-4">
          <div className="grid grid-cols-1 w-[30%] sm:w-full mx-auto bg-white rounded-md">
            <div className="px-8 py-8">
              <h2 className="text-center w-full text-xl text-slate-600 font-bold">
                {t('home.login')}{' '}
              </h2>

              <div>
                <form onSubmit={login} className="text-slate-600">
                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="phone">{t('home.phone')}</label>
                    <input
                      onChange={inputHandle}
                      value={state.phone}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      type="text"
                      name="phone"
                      id="phone"
                      placeholder="Phone"
                      required
                    />
                  </div>

                  <div className="flex flex-col gap-1 mb-6">
                    <label htmlFor="password">{t('home.password')}</label>
                    <input
                      onChange={inputHandle}
                      value={state.password}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Password"
                      required
                    />
                  </div>

                  <button className="px-8 w-full py-2 bg-primary shadow-lg hover:bg-[#256398] text-white rounded-md">
                    {t('home.login')}
                  </button>
                </form>
                <div className="flex justify-center items-center py-2">
                  {/* <div className="h-[1px] bg-slate-300 w-[95%]"> </div> */}
                  {/* <span className="px-3 text-slate-600">Or</span> */}
                  {/* <div className="h-[1px] bg-slate-300 w-[95%]"> </div> */}
                </div>

                {/* <button className='px-8 w-full py-2 bg-indigo-500 shadow hover:shadow-indigo-500/50 text-white rounded-md flex justify-center items-center gap-2 mb-3'>
        <span><FaFacebookF /> </span>
        <span>Login With Facebook </span>
    </button>

    <button className='px-8 w-full py-2 bg-red-500 shadow hover:shadow-red-500/50 text-white rounded-md flex justify-center items-center gap-2 mb-3'>
        <span><FaGoogle  /></span>
        <span>Login With Google </span>
    </button>  */}
              </div>

              <div className="text-center text-slate-600 pt-4">
                <p>
                  {t('home.dont_have_account')}{' '}
                  <Link
                    to="/register"
                    state={{ from: 'register' }}
                    onClick={() => {
                      localStorage.setItem('fromPage', 'register')
                    }}
                  >
                    Register
                  </Link>
                </p>
              </div>

              {/* <div className="text-center text-slate-600 pt-4">
                <p>
                  <Link
                    to="/register"
                    state={{ from: 'forgot' }}
                    onClick={() => {
                      localStorage.setItem('fromPage', 'forgot')
                    }}
                  >
                    Forgot Password?
                  </Link>
                </p>
              </div> */}

              {/* <a target='_blank' href="http://localhost:3001/login">
     <div className='px-8 w-full py-2 bg-[#02e3e0] shadow hover:shadow-red-500/50 text-white rounded-md flex justify-center items-center gap-2 mb-3'>
            Login As a Seller
     </div>
     </a>
 
     <a target='_blank' href="http://localhost:3001/register">
     <div className='px-8 w-full py-2 bg-[#ad2cc4] shadow hover:shadow-red-500/50 text-white rounded-md flex justify-center items-center gap-2 mb-3'>
            Register As a Seller
     </div>
     </a> */}
            </div>

            {/* <div className="flex justify-center items-center w-full h-full py-4 pr-4">
              <img src="http://localhost:3000/images/login.jpg" alt="" />
            </div> */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Login
